var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof Statistics !== "undefined") return resolve();
	__webpack_require__.l("https://builders.metrocuadrado.com/ptec-builders-frontend-statistics-mf/remoteEntry.js?1.0.7", function(event) {
		if(typeof Statistics !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "Statistics");
}).then(function() { return Statistics; });